"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["children", "borderRadius"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InputGroup = function InputGroup(_ref) {
  var children = _ref.children,
    borderRadius = _ref.borderRadius,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledInputGroup, rest, _react["default"].Children.map(children, function (inputComp, index) {
    return /*#__PURE__*/_react["default"].createElement(InputWrapper, {
      borderRadius: borderRadius,
      className: inputComp.className,
      isFirst: index === 0,
      isLast: index === _react["default"].Children.count(children) - 1
    }, inputComp);
  }));
};
var StyledInputGroup = _styledComponents["default"].div.withConfig({
  displayName: "InputGroup__StyledInputGroup",
  componentId: "sc-1r1xmt5-0"
})(["display:flex;"]);
var INPUT_STYLES = (0, _styledComponents.css)(["border-radius:0;", " ", ";", ";"], function (_ref2) {
  var isLast = _ref2.isLast;
  return !isLast && (0, _styledComponents.css)(["border-right:0;"]);
}, function (_ref3) {
  var isFirst = _ref3.isFirst,
    borderRadius = _ref3.borderRadius;
  return isFirst && (0, _styledComponents.css)(["border-top-left-radius:", ";border-bottom-left-radius:", ";"], borderRadius, borderRadius);
}, function (_ref4) {
  var isLast = _ref4.isLast,
    borderRadius = _ref4.borderRadius;
  return isLast && (0, _styledComponents.css)(["border-top-right-radius:", ";border-bottom-right-radius:", ";"], borderRadius, borderRadius);
});
var withHandledBorders = function withHandledBorders(Component) {
  return (0, _styledComponents["default"])(Component).withConfig({
    displayName: "InputGroup",
    componentId: "sc-1r1xmt5-1"
  })(["", ";input{", ";}"], INPUT_STYLES, INPUT_STYLES);
};
var InputWrapper = withHandledBorders(function (_ref5) {
  var children = _ref5.children,
    className = _ref5.className;
  return /*#__PURE__*/_react["default"].cloneElement(children, {
    className: className
  });
});
InputGroup.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  borderRadius: _propTypes["default"].string
};
InputGroup.defaultProps = {
  className: '',
  borderRadius: '4px'
};
var _default = exports["default"] = InputGroup;